function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.3 11.57A14.81 14.81 0 0112 7.28a14.81 14.81 0 0110.7 4.29L21.3 13A12.81 12.81 0 0012 9.28 12.81 12.81 0 002.7 13zM12 18a4 4 0 114-4 4 4 0 01-4 4zm0-2a2 2 0 10-2-2 2 2 0 002 2z"
});
function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}
export default SvgEyeOpen;